import React from 'react'

import FieldRAG_Icon from "../rag-icon"

const debug = false
// const debug = "FieldRAG_PickerValueNotEmpty"

export default function FieldRAG_PickerValueNotEmpty(props:any) {

    const option = props.field._getOption(props.value)

    debug && console.log(debug, 'render', option, props.value)

    return (
        <div className="ui5-field-picker" onClick={props.onClick}>
            <FieldRAG_Icon className="fl-ac" option={option}/>
            {props.children}
        </div>
    )
}
